import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "./Button";

const viewportSettings = {
  once: true,
  amount: 0.1,
  margin: "0px 0px -50px 0px",
};

const SolutionsSection = () => {
  const solutions = [
    {
      title: "Funding",
      description:
        "Efficiently manage project draws and payment requests, instantly get performance reports, forecast liquidity and capital use in your portfolio.",
      link: "/solutions/funding",
      image: "/solutions/6560f7d02c15faf9c384cf55_img_funding.png",
    },
    {
      title: "Execution",
      description:
        "Get a complete real-time overview of project development, financial and schedule performance, mitigate potential risks to keep your projects on track.",
      link: "/solutions/execution",
      image: "/solutions/6560f7d040ef09d6b1146ca2_img_execution.png",
    },
    {
      title: "Planning",
      description:
        "Coordinate your project timeline and assignments through a single, easy-to-use platform. Keep track of all progress updates and project documentation.",
      link: "/solutions/planning",
      image: "/solutions/6560f7d1332c7603e875062d_img_planning.png",
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewportSettings}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
            Streamline your operations across construction workflows
          </h2>
          <div className="space-y-8 mt-8">
            {solutions.map((solution, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={viewportSettings}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg p-8 lg:p-12 hover:shadow-xl transition-all"
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">
                      {solution.title}
                    </h3>
                    <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                      {solution.description}
                    </p>
                    <Link to={solution.link}>
                      <Button variant="primary">
                        More about {solution.title} →
                      </Button>
                    </Link>
                  </div>
                  <div className="rounded-xl overflow-hidden shadow-md">
                    <img
                      src={solution.image}
                      alt={`${solution.title} - Estabild Solution`}
                      className="w-full h-auto object-cover"
                    />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionsSection;
